import { call, put } from 'redux-saga/effects';

import api from 'api/ApiClient';
import * as actions from 'apps/cart/actions';
import { pushFlashMessage } from 'common/actions';
import { FLASH_ERROR } from 'components/shared/FlashMessages';

export default function* convertOrderToSubscription(action, apiClient = api) {
  try {
    const order = yield call(apiClient.convertOrderToSubscription, {
      order_number: action.order.number,
    });
    yield put(actions.convertOrderToSubscriptionClear(order));
    yield put(actions.saveCartSuccess(order));
    yield put(actions.toggleCartVisibility(true));
  } catch (e) {
    yield put(pushFlashMessage(e.message, FLASH_ERROR));
    yield put(actions.convertOrderToSubscriptionClear());
  }
}
